import request, { PATCH } from '../../utils/request';

export default body => request('/request-records/comments', { method: PATCH, body });
